import Vue from 'vue'

const state = {
  selected: [],
  selectedLayout: 'twoCol',
  lang: null
}

const getters = {
  getLanguage: (state) => {
    return state.lang
  },
  selected: (state) => {
    return state.selected
  },
  getSelectedLayout: (state) => {
    return state.selectedLayout
  },
  isSelectedEmpty: (state) => {
    return state.selected.length === 0
  },
  isCheckedItem: (state) => (product, orderCode) => {
    const targetIndex = state.selected.findIndex((x) => {
      return x.orderCode === orderCode && x.product === product
    })

    return targetIndex >= 0
  },
  getProductList (state) {
    return state.selected
      .filter(item => {
        return item.product === 'pinkfongproducts'
      })
  },
  getLicenseList (state) {
    return state.selected
      .filter(item => {
        return item.product === 'licensedproducts'
      })
  },
  getMediaContentsList (state) {
    return state.selected
      .filter(item => {
        return item.product === 'mediacontent'
      })
  },
  countSelected: function (state) {
    return state.selected.length
  },
  getSelectedData: (state) => {
    return state.selected.map((item) => {
      return {
        code: item.code,
        category: item.product
      }
    })
  }
}

const mutations = {
  initLanguage: function (state, lang) {
    state.lang = lang
  },
  setLayout: function (state, layout) {
    state.selectedLayout = layout
  },
  flush: function (state) {
    state.selected.splice(0, state.selected.length)
  },
  toggleItem: (state, itemInfo) => {
    // item code로 찾아서 있으면 지우고 없으면 추가하고
    // -> Todo item 코드가 아니라 LP_code 또는 option_code (option_code가 없을 경우 LP_code로 대치) 기준이 되야함.
    const targetIndex = state.selected.findIndex(x => x.orderCode === itemInfo.orderCode)
    if (targetIndex >= 0) {
      state.selected.splice(targetIndex, 1)
    } else {
      // 깊은 복사 필요!
      const newItem = {
        ...itemInfo
      }
      state.selected.push(newItem)
    }
  },
  clearItem: (state, clearInfo) => {
    if (clearInfo) {
      const filtered = state.selected.filter((item) => {
        if (clearInfo.product === item.product && (!clearInfo.category || clearInfo.category === item.category.code)) {
          return false
        } else {
          return true
        }
      })
      state.selected.splice(0, state.selected.length)
      Vue.set(state, 'selected', filtered)
    } else {
      state.selected.splice(0, state.selected.length)
    }
  },
  selectAllItem: (state, items) => {
    Vue.set(state, 'selected', state.selected.concat(items))
  }
}

const actions = {

}

export default {
  strict: process.env.NODE_ENV !== 'production',
  state: {
    ...state
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/app/store/modules/selected.js